import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse, OwnerType } from "types";

const useDownloadExperianOwnerDocumentMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		async ({
			id,
			ownerType,
			token,
		}: {
			id: number | string;
			ownerType: OwnerType;
			token: string;
		}) => {
			if (!token) return Promise.reject("Token is missing");
			return autoChecklistService.downloadExperianOwnerDocument(
				id,
				ownerType,
				token,
			);
		},
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Experian Result has been downloaded successfully",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useDownloadExperianOwnerDocumentMutation;
